import ShelfEncrypt from "lib/secure-communication/ShelfEncrypt"
import axios from "axios"
import { authorizationInterceptor, mapApiUrl, refreshTokenInterceptor } from "services/api"

export const apiWithEncryption = axios.create({
  baseURL: mapApiUrl()
})

apiWithEncryption.interceptors.request.use(authorizationInterceptor)

apiWithEncryption.interceptors.request.use(async (config) => {
  const encryptedData = await ShelfEncrypt.encryptData(config.data)

  if (config.data && encryptedData) {
    config.data = encryptedData
  }

  return config
})

apiWithEncryption.interceptors.response.use((response) => {
  return response
}, refreshTokenInterceptor)
